export default __webpack_public_path__ + "static/media/single-project-page-01-img2.289461a6.jpg";